import Button from "@/components/Button";
import {
  compactGlobalToolbarBorderlessAddIconStyle,
  compactGlobalToolbarBorderlessIconStyle,
  globalToolbarIconButtonWrapClassName
} from "@/components/Button/globalAddButtonFilledStyle";
import { compactGlobalNavbarIconBoxClassName } from "@/components/TopActionBar/compactNavbarChrome";
import type { SlotIconName } from "@/components/Icon";
import classNames from "classnames";

type GlobalToolbarIconButtonProps = {
  icon: SlotIconName;
  ariaLabel: string;
  ariaKeyShortcuts?: string;
  testId?: string;
  onClick?(): void;
};

export default function GlobalToolbarIconButton({
  icon,
  ariaLabel,
  ariaKeyShortcuts,
  testId,
  onClick
}: GlobalToolbarIconButtonProps) {
  const isAddIcon = icon === "add";

  return (
    <span className={classNames(globalToolbarIconButtonWrapClassName, compactGlobalNavbarIconBoxClassName)}>
      <Button
        variant="outlined"
        icon={icon}
        iconWeight={800}
        ariaLabel={ariaLabel}
        ariaKeyShortcuts={ariaKeyShortcuts}
        testId={testId}
        onClick={onClick}
        style={isAddIcon ? compactGlobalToolbarBorderlessAddIconStyle : compactGlobalToolbarBorderlessIconStyle}
      />
    </span>
  );
}
